import { createOptimizerWorkerClient as m } from "./createOptimizerWorkerClient.js";
async function c(s, r, l) {
  const { worker: n, api: e } = l ?? m();
  r ? await r() : await e.warmup(), await e.init(s.options, s.excelPath);
  const o = await e.getInitialSnapshot();
  return {
    worker: n,
    service: {
      ...o,
      diminishing: await e.diminishing(),
      refineSpend: (t) => e.refineSpend(t),
      createOptimisedPlans: (t, i, a, d, g) => e.createOptimisedPlans(
        t,
        i ? i.toString() : void 0,
        a ? a.toString() : void 0,
        d,
        g
      ),
      getKPILimits: (t, i, a) => e.getKPILimits(t, i, a),
      getBudgetLimits: (t, i) => e.getBudgetLimits(t, i),
      getTotalKPILimits: (t, i, a) => e.getTotalKPILimits(t, i, a),
      getNonMediaKpi: () => e.getNonMediaKpi(),
      getChannelPeriodFractions: (t, i) => e.getChannelPeriodFractions(t, i),
      getMediasLimits: () => e.getMediasLimits(),
      getActiveDaysPerMedium: () => e.getActiveDaysPerMedium(),
      updateRules: (t) => e.updateRules(t),
      resetOptimisationRules: () => e.resetRules(),
      readMessages: () => e.readMessages(),
      getNaturalDemandData: () => e.getNaturalDemandData(),
      getRoiCurvesData: () => e.getRoiCurvesData(),
      getOptimizerVersion: () => e.getOptimizerVersion(),
      setAllowedWeekdays: (t, i) => e.setAllowedWeekdays(t, i),
      getAllowedWeekdays: (t) => e.getAllowedWeekdays(t),
      getAllAllowedWeekdays: () => e.getAllAllowedWeekdays(),
      clearDailyPlanCache: () => e.clearDailyPlanCache()
    }
  };
}
export {
  c as createWorkerOptimizerPort
};
